<template>
  <div class="box-preview-toolbar-container">
    <span class="box-preview-toolbar-label">{{ $t('edit.canvas.visualizing') }}:</span>
    <div class="box-preview-toolbar">
      <device-button device="desktop"></device-button>
      <device-button device="tablet"></device-button>
      <device-button device="smartphone"></device-button>
    </div>
  </div>
</template>

<script>
import DeviceButton from './DeviceButton';

export default {
  components: {
    DeviceButton,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?4a3b2984
 **/